import axios from 'axios';
import { API_BASE_URL } from './urls';

const clientAxios = axios.create({
    baseURL: API_BASE_URL
});

export default clientAxios;
